import { Stack, TextField } from '@mui/material'
import { useControlStore } from '@editor/stores'
import { SwitchLabeled } from '@ui/actions'
import { useAppStore } from '@stores'

const IFCTransparencyControls = () => {
  const gltfModelTranslucent = useControlStore(state => state.gltfModelTranslucent)
  const setGltfModelTranslucent = useControlStore(state => state.setGltfModelTranslucent)
  const ifcTransparentOpacity = useAppStore(state => state.ifcTransparentOpacity)
  const setIfcTransparentOpacity = useAppStore(state => state.setIfcTransparentOpacity)
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <SwitchLabeled
        checked={gltfModelTranslucent}
        onChange={event => setGltfModelTranslucent(event.target.checked)}
        label="transparent"
        sx={{ padding: 0 }}
      />
      {gltfModelTranslucent && (
        <TextField
          label="Transparenz"
          type="number"
          size="small"
          value={ifcTransparentOpacity}
          onChange={event => {
            const opacity = parseFloat(event.target.value)
            if (!isNaN(opacity) && opacity >= 0 && opacity <= 1) {
              setIfcTransparentOpacity(opacity)
            }
          }}
          inputProps={{ min: 0, max: 1, step: 0.05 }}
          sx={{ width: 100 }}
        />
      )}
    </Stack>
  )
}

export default IFCTransparencyControls
